export function dragCrop(crop, width, height, handle, dx, dy) {
  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
  if (handle === 'move') {
    return { ...crop, x: clamp(crop.x + dx, 0, width - crop.width), y: clamp(crop.y + dy, 0, height - crop.height) };
  }
  const left = handle.includes('w');
  const top = handle.includes('n');
  const anchorX = left ? crop.x + crop.width : crop.x;
  const anchorY = top ? crop.y + crop.height : crop.y;
  const aspect = crop.width / crop.height;
  const horizontal = left ? -dx : dx;
  const vertical = (top ? -dy : dy) * aspect;
  const delta = Math.abs(horizontal) >= Math.abs(vertical) ? horizontal : vertical;
  const maxWidth = Math.min(left ? anchorX : width - anchorX, (top ? anchorY : height - anchorY) * aspect);
  const minWidth = Math.min(maxWidth, Math.min(width, height * aspect) / 10);
  const nextWidth = clamp(crop.width + delta, minWidth, maxWidth);
  const nextHeight = nextWidth / aspect;
  return { x: left ? anchorX - nextWidth : anchorX, y: top ? anchorY - nextHeight : anchorY, width: nextWidth, height: nextHeight };
}
